"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _authInformation = require("@/api/authInformation");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'i-copyright',
  data: function data() {
    return {
      links: [],
      copyright: '',
      copyrightNew: ''
    };
  },
  mounted: function mounted() {
    // if (checkPermi(['platform:copyright:get:info'])) this.getVersion();
  },
  methods: {
    getVersion: function getVersion() {
      // copyrightInfoApi().then((res) => {
      //   const data = res || {};
      //   this.copyrightNew = data.companyName ? data.companyName : this.copyright;
      // });
    }
  }
};